export const recipeMapper = {
  mapIngredients(ingredient) {
    const mappedIngredient = {
      ...ingredient
    };
    mappedIngredient.quantite = Number(ingredient.quantite);
    return mappedIngredient;
  },
  mapRecipe(recipe) {
    const mappedRecipe = {
      ...recipe
    };
    mappedRecipe.quantite_produite = Number(recipe.quantite_produite);
    if (recipe.data) {
      mappedRecipe.data.prix_vente = Number(recipe.data.prix_vente);
      mappedRecipe.data.cost = Number(recipe.data.cost);
      mappedRecipe.data.prix_inventory = Number(recipe.data.prix_inventory);
      mappedRecipe.data.quantity_inventory = Number(
        recipe.data.quantity_inventory
      );
      mappedRecipe.data.quantity_production =
        recipe.data.quantity_production !== null
          ? Number(recipe.data.quantity_production)
          : null;
    }
    mappedRecipe.ingredients = recipe.ingredients.map(i =>
      this.mapIngredients(i)
    );
    return mappedRecipe;
  }
};
